import { render } from "./Romy.vue?vue&type=template&id=69725c06&scoped=true"
import script from "./Romy.vue?vue&type=script&lang=js"
export * from "./Romy.vue?vue&type=script&lang=js"

import "./Romy.vue?vue&type=style&index=0&id=69725c06&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69725c06"]])

export default __exports__